import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const AuthAPI = createApi({
  reducerPath: "AuthAPI",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    getSingleUserAuthDetail: builder.query({
      query: (userID) => {
        return `user_auth/${userID}`
      },
      transformResponse: (response) => response?.data,
    }),
    getUserAuthDetail: builder.query({
      query: (userID) => {
        return `user_auth/${userID}`;
      },
      transformResponse: (response) => response?.data,
    }),
    getSingleUserDetail: builder.query({
      query: (userID) => {
        return `get_single_user/${userID}`;
      },
      transformResponse: (response) => response?.data || {},
    }),
    getAuthDetail: builder.query({
      query: () => {
        return `auth_master`;
      },
      transformResponse: (response) => response?.data || {},
    }),
    updateUserAuthDetail: builder.mutation({
      query: (userUpdatedAuth) => ({
        url: "user_auth",
        method: "PUT",
        body: userUpdatedAuth,
      }),
    }),
    logoutUser: builder.query({
      query: () => {
        return "log_out";
      },
    }),
  }),
});

export const {
  useGetSingleUserAuthDetailQuery,
  useGetUserAuthDetailQuery,
  useGetSingleUserDetailQuery,
  useGetAuthDetailQuery,
  useUpdateUserAuthDetailMutation,
  useLazyLogoutUserQuery,
} = AuthAPI;

export default AuthAPI;
